import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCameraFlip = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M23.25 12C23.2496 14.361 22.5065 16.662 21.1258 18.5772C19.7452 20.4924 17.7971 21.9248 15.5574 22.6715C13.3176 23.4182 10.8997 23.4414 8.64599 22.7378C6.39231 22.0341 4.41708 20.6394 3 18.751"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 8.25L14.25 6.75H9.75L9 8.25H7.5C7.10218 8.25 6.72064 8.40804 6.43934 8.68934C6.15804 8.97064 6 9.35218 6 9.75V14.25C6 14.6478 6.15804 15.0294 6.43934 15.3107C6.72064 15.592 7.10218 15.75 7.5 15.75H16.5C16.8978 15.75 17.2794 15.592 17.5607 15.3107C17.842 15.0294 18 14.6478 18 14.25V9.75C18 9.35218 17.842 8.97064 17.5607 8.68934C17.2794 8.40804 16.8978 8.25 16.5 8.25H15Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.125 11.625C10.125 11.8712 10.1735 12.115 10.2677 12.3425C10.362 12.57 10.5001 12.7767 10.6742 12.9508C10.8483 13.1249 11.055 13.263 11.2825 13.3573C11.51 13.4515 11.7538 13.5 12 13.5C12.2462 13.5 12.49 13.4515 12.7175 13.3573C12.945 13.263 13.1517 13.1249 13.3258 12.9508C13.4999 12.7767 13.638 12.57 13.7323 12.3425C13.8265 12.115 13.875 11.8712 13.875 11.625C13.875 11.3788 13.8265 11.135 13.7323 10.9075C13.638 10.68 13.4999 10.4733 13.3258 10.2992C13.1517 10.1251 12.945 9.98695 12.7175 9.89273C12.49 9.7985 12.2462 9.75 12 9.75C11.7538 9.75 11.51 9.7985 11.2825 9.89273C11.055 9.98695 10.8483 10.1251 10.6742 10.2992C10.5001 10.4733 10.362 10.68 10.2677 10.9075C10.1735 11.135 10.125 11.3788 10.125 11.625V11.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 18.75H3V22.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 12C0.750419 9.63904 1.49355 7.33804 2.87415 5.42282C4.25476 3.5076 6.20288 2.07522 8.44265 1.32852C10.6824 0.581821 13.1003 0.558635 15.354 1.26225C17.6077 1.96586 19.5829 3.36061 21 5.249"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 5.25H21V1.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCameraFlip.displayName = 'SvgCameraFlip';
export default SvgCameraFlip;
